const cookies = require('./cookies')
const dom = require('./dom')
const dynamicContent = require('./dynamic-content')
const errors = require('./errors')
const filters = require('./filters')
const form = require('./form')
const history = require('./history')
const hotjar = require('./hotjar')
const ssn = require('./ssn')
const tracking = require('./tracking')
const zopim = require('./zopim')
const { isClient } = require('./is-client')
const { isDevelopment } = require('./is-development')
const { isLocal } = require('./is-local')
const { isProduction } = require('./is-production')
const { isServer } = require('./is-server')
const { isTest } = require('./is-test')
const { readOnly } = require('./read-only')
const { arraysAreEqual } = require('./arrays-are-equal')
const { isMobileOrTablet } = require('./is-mobile-or-tablet')
const { buildName } = require('./build-name')
const { camelize } = require('./camelize')
const { clone } = require('./clone')
const { getDiffBetweenDatesInDays } = require('./get-diff-between-dates-in-days')
const { currentTime } = require('./current-time')
const { decodeEntities } = require('./decode-entities')
const { deepReplace } = require('./deep-replace')
const { getFragment } = require('./get-fragment')
const { getProp } = require('./get-prop')
const { hasProp } = require('./has-prop')
const { isArray } = require('./is-array')
const { isBool } = require('./is-bool')
const { isEmpty } = require('./is-empty')
const { isNotEmptyObject } = require('./is-not-empty-object')
const { isNumber } = require('./is-number')
const { isObject } = require('./is-object')
const { isString } = require('./is-string')
const { isIe } = require('./is-ie')
const { kebabCase } = require('./kebab-case')
const { likelyLoggedIn } = require('./likely-logged-in')
const { randomString } = require('./random-string')
const { roundNumber } = require('./round-number')
const { size } = require('./size')
const { stringToInt } = require('./string-to-int')
const { toBool } = require('./to-bool')
const { usableValue } = require('./usable-value')
const { removeNullValuesFromObject } = require('./remove-null-values-from-object')
const { filterForCdn } = require('./filter-for-cdn')
const { getCacheKey } = require('./get-cache-key')
const { getUserAttributes } = require('./get-user-attributes')
const { getUserId } = require('./get-user-id')
const { getUserIp } = require('./get-user-ip')
const { includeFragment } = require('./include-fragment')
const { parseHtml } = require('./parse-html')
const { removeProjectPrefix } = require('./remove-project-prefix')
const { stateId } = require('./state-id')
const { useMiddlewareUnless } = require('./use-middleware-unless')
const { randomNumber } = require('./random-number')
const { setLocale } = require('./set-locale')
const { isStaticFile } = require('./is-static-file')

module.exports = {
  ...cookies,
  ...dom,
  ...dynamicContent,
  ...errors,
  ...filters,
  ...form,
  ...history,
  ...hotjar,
  ...ssn,
  ...tracking,
  ...zopim,
  isClient,
  isDevelopment,
  isLocal,
  isProduction,
  isServer,
  isTest,
  readOnly,
  arraysAreEqual,
  isMobileOrTablet,
  buildName,
  camelize,
  clone,
  getDiffBetweenDatesInDays,
  currentTime,
  decodeEntities,
  deepReplace,
  getFragment,
  getProp,
  hasProp,
  isArray,
  isBool,
  isEmpty,
  isNotEmptyObject,
  isNumber,
  isObject,
  isString,
  isIe,
  kebabCase,
  likelyLoggedIn,
  randomString,
  roundNumber,
  size,
  stringToInt,
  toBool,
  usableValue,
  removeNullValuesFromObject,
  filterForCdn,
  getCacheKey,
  getUserAttributes,
  getUserId,
  getUserIp,
  includeFragment,
  parseHtml,
  removeProjectPrefix,
  stateId,
  useMiddlewareUnless,
  randomNumber,
  setLocale,
  isStaticFile
}
